export default "__VITE_ASSET__Bfa0i5$A__"